import { ViewController } from 'ionic-angular/navigation/view-controller';
import { SMS } from '@ionic-native/sms';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the SmsGonderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-sms-gonder',
  templateUrl: 'sms-gonder.html',
})
export class SmsGonderPage {
  vWKayit: any = {};
  kayit:any={};
   textsms="";
   numara="";
  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public viewCtrl:ViewController,
   
     public navParams: NavParams) {
    if (navParams.get("vWKayit") != null) {
      this.vWKayit = navParams.get("vWKayit");
      var data = new FormData();
 
      data.append("Servis_id", this.vWKayit.ID);
      this.bllOrtak.islem(data, "ServisGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.kayit = Sonuc.SonucObject;
        this.numara=this.kayit.GsmNo;
      
      }
      )
  
    }
  }


  // gonder()
  // {
   
  //   this.sms.send(this.numara,this.textsms);
  //   this.viewCtrl.dismiss();
  // }
  kapat(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/sms-gonder/sms-gonder.ts